<template>
  <explore-report 
    :dashboard-id="$route.params.dashboard_id"  
    :report-id="$route.params.report_id"  
    />
</template>

<script>
  import ExploreReport from './CustomReportsManager/ExploreReport';

  export default {
    name: 'ExploreDashboard',
    components: { ExploreReport },
  };
</script>
